import React from 'react';
import { motion } from 'framer-motion';

const variantStyles = {
  primary:
    'bg-slate-950 text-white shadow-[0_16px_40px_rgba(15,23,42,0.18)] hover:bg-slate-800 dark:bg-slate-800 dark:text-slate-100 dark:hover:bg-slate-700 dark:shadow-none dark:ring-1 dark:ring-white/15',
  secondary:
    'border border-slate-200 bg-white text-slate-900 hover:bg-slate-50 dark:border-white/10 dark:bg-white/5 dark:text-white dark:hover:bg-white/10',
  ghost:
    'bg-transparent text-slate-700 hover:bg-slate-100 dark:text-slate-300 dark:hover:bg-white/5',
  subtle:
    'bg-cyan-500/10 text-cyan-700 hover:bg-cyan-500/15 dark:text-cyan-200',
};

/** Purpose: render a shared styled action button. Why: consistent variants, loading, and disabled states reduce visual and interaction drift. */
export default function SaaSButton({
  as: Comp = motion.button,
  variant = 'primary',
  className = '',
  children,
  ...props
}) {
  return (
    <Comp
      whileHover={{ y: -1 }}
      whileTap={{ scale: 0.98 }}
      className={[
        'inline-flex items-center justify-center gap-2 rounded-full px-4 py-3 text-sm font-semibold transition focus:outline-none focus:ring-2 focus:ring-cyan-400/30',
        variantStyles[variant] || variantStyles.primary,
        className,
      ].join(' ')}
      {...props}
    >
      {children}
    </Comp>
  );
}
